import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import ActiviteTypeCreation from "../../../components/Admin/ActiviteTypes/ActiviteTypeCreation";
import ActiviteTypeVue from "../../../components/Admin/ActiviteTypes/ActiviteTypeVue";

function AdminActiviteTypePage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [activiteType, setActiviteType] = useState({});
    const {activiteTypeId} = useParams();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    useEffect(() => {
        (async () => {
            try {
                const response = await AxiosConfig.get(`/admin/activites/types/${activiteTypeId}`);
                setMyApiData(response.data.myActiviteType);
                setActiviteType(response.data.myActiviteType);
            } catch (error) {
                console.error('error', error);
            }
        })();
    }, [user]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ activiteType }));
    }, [activiteType]);

    return (
        <div className="content">
            <TitleMain text={myApiData.actLabel}/>

            {mode === 'creation' ?
                    <ActiviteTypeCreation activiteType={myApiData} />
                :
                (
                    <ActiviteTypeVue activiteType={myApiData} />
                )
            }

        </div>
    )
}

export default AdminActiviteTypePage;
